(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/lb-ui/betslip/assets/javascripts/betslip.js') >= 0) return;  svs.modules.push('/components/lb-ui/betslip/assets/javascripts/betslip.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const _React = React,
  useEffect = _React.useEffect,
  useRef = _React.useRef,
  useState = _React.useState,
  useCallback = _React.useCallback;
const _svs$components$lbUi$ = svs.components.lbUi.betslip,
  PaymentButton = _svs$components$lbUi$.PaymentButton,
  BetslipContext = _svs$components$lbUi$.BetslipContext;
const detect = svs.core.detect;
const useWindowSize = svs.components.lbUtils.useWindowSize;
function isScrolledIntoView(el, parent) {
  if (!el || !parent) {
    return false;
  }
  const rect = el.getBoundingClientRect();
  const elemTop = rect.top;
  const elemBottom = rect.bottom;
  let isVisible;
  if (parent === window) {
    isVisible = elemTop >= 0 && elemBottom <= parent.innerHeight;
  } else {
    const parentRect = parent.getBoundingClientRect();
    isVisible = elemBottom <= parentRect.bottom && elemTop > parentRect.top;
  }
  return isVisible;
}
function isScrolledIntoViewAsRelative(el) {
  const oldPosition = el.style.position;
  el.style.position = '';
  const intoView = isScrolledIntoView(el, window);
  el.style.position = oldPosition;
  return intoView;
}
const Betslip = _ref => {
  let children = _ref.children,
    accountBalance = _ref.accountBalance,
    errorMessage = _ref.errorMessage,
    _ref$isPayable = _ref.isPayable,
    isPayable = _ref$isPayable === void 0 ? true : _ref$isPayable,
    isSelfService = _ref.isSelfService,
    onPay = _ref.onPay,
    price = _ref.price,
    getScrollContainer = _ref.getScrollContainer;
  const priceClassNames = ['betslip-sticky-price'];
  if (isPayable) {
    priceClassNames.push('betslip-sticky-price-is-payable');
  }
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isPayButtonVisible = _useState2[0],
    setPayButtonVisible = _useState2[1];
  const payButtonRef = useRef();
  const stickyRef = useRef();
  const stickyPlaceholderRef = useRef();
  const isStickyInView = useRef();
  const makeStickyIE11 = useCallback(() => {
    if (detect.browser.ie()) {
      if (isScrolledIntoViewAsRelative(stickyRef.current)) {
        stickyRef.current.style.position = '';
        stickyRef.current.style.width = '';
        stickyPlaceholderRef.current.classList.remove('betslip-sticky-placeholder-active');
        isStickyInView.current = true;
      } else {
        stickyPlaceholderRef.current.classList.add('betslip-sticky-placeholder-active');
        stickyRef.current.style.position = 'fixed';
        if (getScrollContainer && getScrollContainer()) {
          stickyRef.current.width = getScrollContainer();
          stickyRef.current.style.width = window.getComputedStyle(getScrollContainer()).width;
        }
        isStickyInView.current = false;
      }
    }
  }, [getScrollContainer]);
  const _useWindowSize = useWindowSize(),
    width = _useWindowSize.width;
  useEffect(() => {
    if (detect.browser.ie()) {
      if (isStickyInView.current) {
        stickyRef.current.style.width = '';
      } else if (getScrollContainer && getScrollContainer()) {
        stickyRef.current.width = getScrollContainer();
        stickyRef.current.style.width = window.getComputedStyle(getScrollContainer()).width;
      }
    }
  }, [width, getScrollContainer]);
  useEffect(() => {
    let scrollElement = window;
    function onScroll() {
      if (isScrolledIntoView(payButtonRef.current, scrollElement)) {
        setPayButtonVisible(true);
      } else {
        setPayButtonVisible(false);
      }
      makeStickyIE11();
    }
    if (getScrollContainer && getScrollContainer()) {
      scrollElement = getScrollContainer();
    }
    scrollElement.addEventListener('scroll', onScroll);
    return () => {
      scrollElement.removeEventListener('scroll', onScroll);
    };
  }, [getScrollContainer, makeStickyIE11]);
  useEffect(() => {
    makeStickyIE11();
  }, [makeStickyIE11]);
  return React.createElement(BetslipContext.Provider, {
    value: {
      getScrollContainer,
      accountBalance,
      errorMessage,
      isPayable,
      isSelfService,
      onPay,
      price,
      isPayButtonVisible,
      stickyRef,
      stickyPlaceholderRef,
      payButtonRef
    }
  }, children, React.createElement(PaymentButton, {
    ref: payButtonRef
  }));
};
setGlobal('svs.components.lbUi.betslip.Betslip', Betslip);

 })(window);